import React from 'react'

class ImageViewer extends React.Component {
  static defaultProps = {
    onLoadError: () => null,
    onLoadSuccess: () => null,
    src: '',
  }

  state = {
    src: '',
    width: null,
  }

  imgRef = React.createRef()

  componentDidMount() {
    let img = new Image()
    img.crossOrigin = 'Anonymous'
    img.onload = () => {
      var canvas = document.createElement('canvas')
      var context = canvas.getContext('2d')
      canvas.height = img.naturalHeight
      canvas.width = img.naturalWidth
      context.drawImage(img, 0, 0)
      this.props.onLoadSuccess()
      this.setState({ src: canvas.toDataURL('image/jpeg') })
    }
    img.onerror = this.props.onLoadError
    setTimeout(() => (img.src = this.props.src), 200)
  }

  onLoad = () => {
    this.setState({ width: this.imgRef.current.clientWidth })
  }

  render() {
    let { width, src } = this.state
    let { scale } = this.props

    width = width ? width * scale : undefined
    let maxWidth = width ? undefined : '100%'
    let imgStyle = { maxWidth, width }

    if (!src) return null
    return (
      <img
        className="with-shadow p-2 bg-white"
        style={imgStyle}
        ref={this.imgRef}
        src={src}
        alt="img preview"
        onLoad={this.onLoad}
      />
    )
  }
}

export default ImageViewer
